function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import deepEqual from 'fast-deep-equal';
/**
 * Setup a replace reducer for a specific action type.
 * Will take the payload passed in and replace the entity at the id with the payload
 * @param type The action type
 */
export default function replaceByIdReducer(type) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var checkIfChanged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch (action === null || action === void 0 ? void 0 : action.type) {
      case type:
        {
          var id = action.id,
            payload = action.payload;
          if (checkIfChanged && deepEqual({
            payload
          }, {
            payload: state[id]
          })) {
            return state;
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            [id]: payload
          });
        }
      default:
        return state;
    }
  };
}
//# sourceMappingURL=replaceByIdReducer.js.map